module.exports = __webpack_public_path__ + "static/img/17.d05a1f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/17.jpg
// module id = zQwP
// module chunks = 16